import dotenv from 'dotenv'
dotenv.config()
const {
  REACT_APP_API_URL,
  REACT_APP_API_PUBLIC_URL,
  REACT_APP_FRAME_PARENT_URL,
  REACT_APP_REPORT_URL,
  REACT_APP_DOWNLOAD_URL,
  REACT_APP_IS_IFRAME,
  REACT_APP_EXTERNAL_API,
  REACT_APP_API_CUSTOM_CDR,
  APP_THEME_NAME,
  REACT_APP_CUSTOM_CDR_DOWNLOAD_URL,
  REACT_APP_CLOUD_ICON,
  REACT_APP_CLOUD_MENU_ICON,
  REACT_APP_RCS_URL,
} = process.env;
// eslint-disable-next-line no-restricted-globals
const loc = location.hostname;
console.log("process.env", process.env, process.env.CLOUD_MENU_ICON);
export const apiUrl = REACT_APP_API_URL
  ? REACT_APP_API_URL
  : `http://21de-103-205-125-230.ngrok.io/`;

export const apiUrlPublic = REACT_APP_API_PUBLIC_URL
  ? REACT_APP_API_PUBLIC_URL
  : `http://9c51-103-205-125-230.ngrok.io/`;
//COMPULSORY USE ENV FOR THIS
export const apiFrameParentUrl = REACT_APP_FRAME_PARENT_URL;

export const reportUrl = REACT_APP_REPORT_URL
  ? REACT_APP_REPORT_URL
  : `https://alpha-cloud.streamspace.ai/v1/auth/`;

export const customCDR = REACT_APP_API_CUSTOM_CDR
  ? REACT_APP_API_CUSTOM_CDR
  : `https://alpha-cloud.streamspace.ai/v1/auth/`;

export const downloadCustomCDR = REACT_APP_CUSTOM_CDR_DOWNLOAD_URL
  ? REACT_APP_CUSTOM_CDR_DOWNLOAD_URL
  : `https://alpha-cloud.streamspace.ai/v1/auth/`;

export const downloadUrl = REACT_APP_DOWNLOAD_URL
  ? REACT_APP_DOWNLOAD_URL
  : `https://alpha-cloud.streamspace.ai/v1/auth/`;

  // export const rcs_Url = REACT_APP_RCS_URL
  // ? REACT_APP_RCS_URL
  // : `https://rcstest.webpostservice.com:8000/`

export const externalApi = '';

export const app_theme = APP_THEME_NAME || 'tcc1';

export const modalType = app_theme === 'tcc1' ? 'right' : '';

export const leftSidebarType = app_theme === 'tcc1' ? false : true;


export const companyIcon = REACT_APP_CLOUD_ICON ? REACT_APP_CLOUD_ICON : "TLight.png";
export const companyMenuIcon = REACT_APP_CLOUD_MENU_ICON ? REACT_APP_CLOUD_MENU_ICON : "tublight-logo.png";



// WEBPACK FOOTER //
// ./src/helpers/dotenv.js